import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { IconButton } from "components/common";
import { Alert } from "components/bootstrap";
import { Row, Col } from "security-app/components/common/FormBaseStyles";
const StyledAlert = styled(Alert)`
  & .mantine-Alert-label {
    width: 100%;
  }
`;
function ImportErrorsAlert({ importErrors, setImportErrors }) {
  const formatedImportErrors = useMemo(
    () => importErrors.map((err) => err.match(/\[(?<ruleId>.+)\]: \[(?<message>.+)\]/).groups),
    [importErrors]
  );
  return /* @__PURE__ */ React.createElement(
    StyledAlert,
    {
      bsStyle: "warning",
      style: { width: "100%" },
      title: /* @__PURE__ */ React.createElement(Row, { $width: "100%", $justify: "space-between" }, /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement("strong", null, "Import Errors")), /* @__PURE__ */ React.createElement(IconButton, { size: "xs", name: "close", title: "Clear errors", onClick: () => setImportErrors([]) }))
    },
    /* @__PURE__ */ React.createElement(Col, { $width: "100%", $gap: "0.5rem" }, formatedImportErrors.map((error) => /* @__PURE__ */ React.createElement(Row, { key: error.ruleId, $width: "100%", $gap: "0.5rem" }, /* @__PURE__ */ React.createElement("strong", null, error.ruleId, ":"), /* @__PURE__ */ React.createElement("span", null, error.message))))
  );
}
export default ImportErrorsAlert;
